import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment.development';
import { ConsentModel } from '../../common/Models/ConsentModel';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConsentToAccessService {
  UserData: any = null;
  isLoggedIn: boolean = false;
  isVLEuser: boolean = false;
  lastupdate_goldenrecord_date: boolean=false;

  constructor(private http: HttpClient) {
    // console.log(sessionStorage.getItem('userData'));
    if (sessionStorage.getItem('userData')) {
      // console.log(sessionStorage.getItem('userData'));
      this.isLoggedIn = true;
      let isvle = JSON.parse(sessionStorage.getItem('userData')).usercategory == "vle" ? true : false;
      if(isvle){
        this.isVLEuser = true;
      }
    }
  }

  public getIPAddress() {
    return this.http.get("https://api.ipify.org/?format=json");
  }

  ActiveUserData(data: any) {
    this.UserData = data;
  };
  public getIP() {
    return this.http.get(environment.MasterAPI + "Consent/IpAddress");
  }
  // API URL

  //private urlConsentDataRegistry: string = environment.MasterAPI + "Consent/ConsentData";
  //private urlDummyLogin: string = environment.MasterAPI + "Consent/DummyLogin";
  private urlSendOTP: string = environment.CommonAPI + 'sms/generateOTP';
  private urlVerifyOTP: string = environment.CommonAPI + 'SMS/VerifyOTP';
  private apiUrl : string = environment.MasterAPI + 'Consent/UpdateConsentHistoryAttributeId';
  private urlgetconsent:string = environment.ConsentManagerAPI + 'ConsentManager/getLatestConsent';
  private urlGetAttributeTitle = environment.MasterAPI + "Citizen/GetAttributeTitle"
  private urlConsentDataRegistry: string = environment.ConsentManagerAPI + "ConsentManager/ConsentStatus";
  private urlGetApproveAttribute:string = environment.MasterAPI + "Citizen/GetApproveAttribute"
    private urlGetLatestConsentRegistration:string = environment.ConsentManagerAPI + "Data/GetLatestConsentRegistration"
  // Methods

  consentDataRegistryLog(Body: ConsentModel) {
    return this.http.post(this.urlConsentDataRegistry, Body);
  }
  getConsentDataRegistryLog(Body){
    return this.http.post(this.urlConsentDataRegistry, Body);
  }
  ConsentDataRegistryLogLatest(Body) {
    return this.http.post(this.urlConsentDataRegistry, Body);
  }
  GetLatestConsent(Body){
    return this.http.post(this.urlgetconsent , Body )
  }
    GetLatestConsentRegistration(body){
    return this.http.post(this.urlGetLatestConsentRegistration , body )
  }
  GetAttributeTitle(attributeid: string){
    return this.http.get(`${this.urlGetAttributeTitle}?attributeid=${attributeid}`);
  }
  GetAttributeIds(citizen_unique_id :string, attributeids : string){
    return this.http.get(`${this.urlGetApproveAttribute}?citizen_unique_id=${citizen_unique_id}&attributeids=${attributeids}`);
  }

 

  // Temporary Methods
  private loginTrigger = new Subject<boolean>()
  public loginListenerMsg$ = this.loginTrigger.asObservable();

  LoginSignal(msg: boolean) {
    this.loginTrigger.next(msg);
  }

  sendOTP(data) {
    // return this.http.post(this.urlSendOTP, data);
    return this.http.post(environment.MasterAPI + "Consent/SendOTP", data);
  }
  verifyOTP(data) {
    return this.http.post(environment.MasterAPI + "Consent/GetUserOTP", data);
    // return this.http.post(this.urlVerifyOTP, data);
  }
  getConsentData(): Observable<any[]> {
    return this.http.get<any[]>('assets/data/consent-english.json');
  }

  getConsentDataforMarathi(): Observable<any[]> {
    return this.http.get<any[]>('assets/data/consent-marathi.json');
  }
  getConsentManagData(): Observable<any[]> {
    return this.http.get<any[]>('assets/data/consent-management-english.json');
  }

  getConsentManagMarathi(): Observable<any[]> {
    return this.http.get<any[]>('assets/data/consent-management-marathi.json');
  }

  getTranslationFromTransaltedPipe(): Observable<any[]> {
    return this.http.get<any[]>('assets/data/lang/mr.json');
  }
  updateConsentHistoryAttributeId(consentId: number, attributeid: string): Observable<any> {
    const body = {
      consentId: consentId,
      attributeid: attributeid
    };
    return this.http.post(this.apiUrl, body);
  }
}
